// extracted by mini-css-extract-plugin
module.exports = {"Card":"thematics-nav-item_Card__rwLd5","Anchor":"thematics-nav-item_Anchor__lvGvy"};